<template>
  <div class="qest_lay_win2 text_center">
    <div>
      <img src="~assets/findlawyers/find_sample2.png" />
    </div>
    <div class="ol_law_info">
      <div class="simple_des">
        <div class="name">{{item.lawyer_name}} <span>专职律师</span></div>
        <div class="des ellipsis">擅长领域：{{item.goodat}}</div>
      </div>
      <div class="detail_des text_center">
        <div class="name">{{item.lawyer_name}} <span>专职律师</span></div>
        <div class="good_at">{{item.goodat}}</div>
        <div class="phone center">
          <svg-icon icon-class="dianhua" class="svgimg" /> {{item.lawyer_mobile}}
        </div>
		<router-link to="/question/onlitform">
        <div class="consult center text_hover_shou">在线咨询</div>
		</router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
	props:{
		item:{
			type:Object
		}
	}
	
};
</script>

<style lang="scss" scope>
.qest_lay_win2 {
  position: relative;
  &:hover {
    .ol_law_info {
      transition: height 0.3s;
      height: 150px;
      .simple_des {
        display: none;
      }
    }
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    box-shadow: 0px 1px 7px 0px rgba(0, 0, 0, 0.08);
  }
  .ol_law_info {
    position: absolute;
    bottom: -10%;
    left: 5.5%;
    width: 89%;
    height: 91px;
    box-shadow: 0px 1px 7px 0px rgba(0, 0, 0, 0.08);
    background-color: #fff;
    overflow: hidden;

    .simple_des {
      width: 100%;
      padding: 18px 0;
      .name {
        font-size: 18px;
        color: #282828;
        > span {
          font-size: 12px;
          color: #999999;
          margin-left: 3px;
        }
      }
      .des {
        margin-top: 10px;
        font-size: 14px;
        color: #999999;
      }
    }

    .detail_des {
      color: #666666;
      width: 100%;
      padding: 16px 0 ;
      height: 0;
      .name {
        font-size: 18px;
        color: #282828;
        > span {
          font-size: 12px;
          color: #999999;
          margin-left: 3px;
        }
      }
      .good_at {
        margin-top: 8px;
        font-size: 14px;
        color: #999999;
      }
      .phone {
        margin: 10px 0;
        font-size: 16px;
        .svgimg {
          font-size: 14px;
          color: #1375ff;
          margin-right: 2px;
        }
      }
      .more {
        font-size: 12px;
      }
      .consult {
        width: 82px;
        height: 23px;
        margin: 0 auto;
        font-size: 14px;
        background: #f25618;
        border-radius: 5px;
        color: #fff;
      }
    }
  }
}
</style>